import requestModule from '@/application/libs/requestModule'

export default {

    /**
     * Do the login request passing all login
     * data as parameter and returning dataset that
     * contains loginData.
     * 
     * @param {Object} loginData 
     * 
     * @returns {Promise}
     */
    login:function(loginData){
        return requestModule.postRequest('login', loginData)
            .then(response=>{
                if(response.dataset){
                    const {loginData, paramGeralData, permissions, token, canAccessPermissionManagement} = response.dataset;
                    return {
                        loginData,
                        paramGeralData,
                        permissions,
                        token,
                        canAccessPermissionManagement
                    }
                }
            });
    },
    testRequest: function(){
        return requestModule.postRequest('testConnection');
    }
}